import React from 'react'
import HeaderNav from './Headers/HeaderNav'
import Header from 'components/Headers/Header';
import Loader from './Loader';

interface PageProps {
  children?: React.ReactNode;
  title?: string;
  className?: string;
  border?: boolean;
  Sticky?: React.ComponentType<any>;
  menu?: boolean;
  StickFooter?: React.ComponentType<any>;
  noneHeader?: boolean;
  containerClass?: string;
  rightButton?: { icon: string; onClick: () => void };
  // Real usages pass either a native form submit handler or react-hook-form's
  // `handleSubmit(...)` result; typed loosely to cover both call shapes.
  onSubmit?: (e?: any) => void;
  loading?: boolean;
  onBack?: () => void;
}

const Page = ({
  children,
  title,
  className,
  border, Sticky,
  menu,
  StickFooter,
  noneHeader,
  containerClass,
  rightButton,
  onSubmit,
  loading,
  onBack,
}: PageProps) => {
  if (onSubmit) {
    return <form onSubmit={onSubmit} className={`page-container ${containerClass || ''}`}>
      {!noneHeader ? <>{menu ? <Header component title={title} rightButton={rightButton} /> : <HeaderNav onBack={onBack} title={title} />}</> : null}
      {border && <div style={{ borderBottom: '1px solid #E5E5E5' }}></div>}
      {Sticky ? <Sticky /> : null}
      <div className='scroll-container'>
        <div className={`scroll-div ${className}`}>
          {children}
        </div>
      </div>
      {StickFooter ? <StickFooter /> : null}
    </form>
  }
  return (
    <>
      {!!loading && <Loader />}
      <div className={`page-container ${containerClass || ''}`}>
        {!noneHeader ? <>{menu ? <Header component title={title} rightButton={rightButton} /> : <HeaderNav onBack={onBack} title={title} />}</> : null}
        {border && <div style={{ borderBottom: '1px solid #E5E5E5' }}></div>}
        {Sticky ? <Sticky /> : null}
        <div className='scroll-container'>
          <div className={`scroll-div ${className}`}>
            {children}
          </div>
        </div>
        {StickFooter ? <StickFooter /> : null}
      </div>
    </>
  )
}

export default Page;
